(function() {
  function initGiftCardLayout() {
    const giftCardForm = document.querySelector('.gift-card-recipient-form');
    if (!giftCardForm) return;

    const productDetails = document.querySelector('.product-details');
    if (!productDetails) return;

    const priceBlock = productDetails.querySelector('product-price');
    const productFormButtons = productDetails.querySelector('.product-form-buttons');
    const quantitySelector = productFormButtons?.querySelector('.quantity-selector');
    
    if (!priceBlock || !productFormButtons || !quantitySelector) return;

    // Criar wrapper para preço + quantity
    const wrapper = document.createElement('div');
    wrapper.className = 'gift-card-price-qty-row';
    
    // Inserir wrapper antes do product-form-buttons
    productFormButtons.parentNode.insertBefore(wrapper, productFormButtons);
    
    // Mover preço para o wrapper
    wrapper.appendChild(priceBlock);
    
    // Mover quantity para o wrapper
    wrapper.appendChild(quantitySelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCardLayout);
  } else {
    initGiftCardLayout();
  }
})();